import { NumberInput } from '@chakra-ui/react/number-input'
import { IconButton } from '@web/components/atoms/Button'
import { Group, HStack } from '@web/components/atoms/Layout'
import { LuMinus, LuPlus } from 'react-icons/lu'
import { PageButton } from '@web/components/page-components/PageButton'
import { useVirtualGiftSection } from './VirtualGiftSectionProvider'

const VirtualGiftSectionQuantity = () => {
  const { setStep, quantity, setQuantity, settings } = useVirtualGiftSection()
  return (
    <Group w="100%">
      <NumberInput.Root
        defaultValue="1"
        min={1}
        max={settings?.styles?.options?.quantity || undefined}
        unstyled
        spinOnPress={false}
        value={`${quantity}`}
        onValueChange={(value) => setQuantity(value.valueAsNumber)}
      >
        <HStack gap="2" w="100%" justifyContent="start">
          <NumberInput.DecrementTrigger asChild>
            <IconButton buttonAppearance="text-border" size="sm">
              <LuMinus />
            </IconButton>
          </NumberInput.DecrementTrigger>
          <NumberInput.ValueText textAlign="center" fontSize="lg" minW="3ch" />
          <NumberInput.IncrementTrigger asChild>
            <IconButton buttonAppearance="text-border" size="sm">
              <LuPlus />
            </IconButton>
          </NumberInput.IncrementTrigger>
        </HStack>
      </NumberInput.Root>
      <PageButton
        id="add-to-cart"
        name="Primary"
        onClick={() => {
          setStep(1)
        }}
        buttonText="Add to Cart"
      />
    </Group>
  )
}

export default VirtualGiftSectionQuantity
